import ActiveApplications, { renderHeader, type Props } from "../active_applications";
import { DashboardSuspense } from "../dashboard_suspense";

const Applications = (props: Props) => {
  return (
    <div className="active-applications">
      <DashboardSuspense renderHeader={renderHeader}>
        <ActiveApplications {...props} />
      </DashboardSuspense>
    </div>
  );
};

export default Applications;
